import { Button, ButtonVariants } from '@components/button/Button';
import { getInitials } from '@utils/formatName';
import cx from 'classnames';
import { Link, NavLink } from 'react-router-dom';
import typography from '~styles/typography.scss';
import {
  AuthModalTypes,
  useAuthModalContext,
} from '../context/AuthModalContext';
import { useUserContext } from '../context/UserContext';
import {
  ACCOUNT_ROOT_PATH,
  HIRING_PATH,
  OFFERS_ROOT_PATH,
  RESERVATIONS_ROOT_PATH,
} from '../paths';
import styles from './Navigation.scss';

export const Navigation = () => {
  const { user, isAuthenticated } = useUserContext();
  const { openModal } = useAuthModalContext();

  const linkClassNames = cx(styles.link, typography.t1);
  const navLinkClassNames = (activeLink: boolean) =>
    cx(linkClassNames, {
      [styles.linkActive]: activeLink,
    });

  return (
    <>
      <NavLink
        className={({ isActive }) => navLinkClassNames(isActive)}
        end
        to={RESERVATIONS_ROOT_PATH}
      >
        Reservations
      </NavLink>
      <NavLink
        className={({ isActive }) => navLinkClassNames(isActive)}
        end
        to={OFFERS_ROOT_PATH}
      >
        Offers
      </NavLink>
      {isAuthenticated ? (
        <Link
          className={styles.badge}
          aria-label="My Account"
          to={ACCOUNT_ROOT_PATH}
        >
          {getInitials(user?.firstName, user?.lastName)}
        </Link>
      ) : (
        <div className={styles.container}>
          <Button
            onClick={() =>
              openModal(AuthModalTypes.SIGN_IN, { hideCreateAccount: true })
            }
            label="Login"
            variant={ButtonVariants.Tertiary}
          />
        </div>
      )}
    </>
  );
};
